import React from "react";

import { NameFilter } from "./nameFilter";
import { TypesFilter } from "./typesFilter";
import { Props } from "./types";
import styles from "./styles.scss";

function Filters({ query, edit, search }: Props) {
  return (
    <div className={styles.filters}>
      <div className={styles.name}>
        <NameFilter
          name={query.name}
          edit={(name) => edit({ ...query, name })}
          submit={(name) => search({ ...query, name })}
          search={(name) => search({ ...query, name })}
        />
      </div>
      <div className={styles.types}>
        <TypesFilter
          type={query.types ? query.types[0] : undefined}
          search={(type) => {
            const types = type ? [type] : type;

            edit({ ...query, types });
            search({ ...query, types });
          }}
        />
      </div>
    </div>
  );
}

export { Filters };
